export default {"src":"/_next/static/media/governance.9b97706f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};